/**
 * CRE Video Management API (CreReportingMicroservice).
 * See CRE_Video_API_Integration_Guide.html — list, download, delete only.
 * Upload/recording is handled by the MedClip extension.
 */
import { createHttpClient } from "../api/httpClients/createHttpClient";
import { getApiBaseUrlsForAuth } from "../config/apiBaseUrlsConstants";
import { AUTH_SOURCE } from "../constants/authSource";

const creReportingClient = createHttpClient({
  resolveBaseURL: () => getApiBaseUrlsForAuth(AUTH_SOURCE.CRE).reporting,
});

/**
 * @param {{ studyId?: string, accessionNumber?: string, pageIndex?: number, pageSize?: number }} params
 */
export async function listCreVideos({
  studyId,
  accessionNumber,
  pageIndex = 0,
  pageSize = 20,
} = {}) {
  const query = new URLSearchParams({
    pageIndex: String(pageIndex),
    pageSize: String(pageSize),
  });
  if (studyId) query.set("studyId", studyId);
  if (accessionNumber) query.set("accessionNumber", accessionNumber);

  const response = await creReportingClient.get(
    `/api/VideoManagement/list?${query.toString()}`,
  );
  return response.data;
}

/** Fresh SAS playback/download URL (30 min). */
export async function getCreVideoDownloadUrl(streamId) {
  const response = await creReportingClient.get(
    `/api/VideoManagement/download/${encodeURIComponent(streamId)}`,
  );
  return response.data;
}

export async function deleteCreVideo(streamId) {
  const response = await creReportingClient.delete(
    `/api/VideoManagement/delete/${encodeURIComponent(streamId)}`,
  );
  return response.data;
}
